var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 6C0.25 2.82436 2.82436 0.25 6 0.25H16C19.1756 0.25 21.75 2.82436 21.75 6V16C21.75 19.1756 19.1756 21.75 16 21.75H6C2.82436 21.75 0.25 19.1756 0.25 16V6ZM6.25 16C6.25 16.4142 6.58579 16.75 7 16.75C7.41421 16.75 7.75 16.4142 7.75 16V13C7.75 12.5858 7.41421 12.25 7 12.25C6.58579 12.25 6.25 12.5858 6.25 13V16ZM11 16.75C10.5858 16.75 10.25 16.4142 10.25 16V6C10.25 5.58579 10.5858 5.25 11 5.25C11.4142 5.25 11.75 5.58579 11.75 6V16C11.75 16.4142 11.4142 16.75 11 16.75ZM14.25 16C14.25 16.4142 14.5858 16.75 15 16.75C15.4142 16.75 15.75 16.4142 15.75 16V9C15.75 8.58579 15.4142 8.25 15 8.25C14.5858 8.25 14.25 8.58579 14.25 9V16Z",
    fill: "#2A2A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartAnalysis);
export default __webpack_public_path__ + "static/media/Chart_analysis.09ec35a30b710abc85b5672d8c55b541.svg";
export { ForwardRef as ReactComponent };